import * as d3 from 'd3-selection'
import extended from './extended-labels'
import narrow from './narrow-labels'
import * as colors from 'colors'

const titleHeight = 17

/*
 * Draws the stage number
 */
const stage = (selection, config) => {
  selection.each(function (d) {
    let group = d3.select(this)
                  .selectAll('g.stage-number')
                  .data(d => config.stage ? [d] : [])
      , enter = group.enter()
                     .append('g')
                     .attr('class', 'stage-number centered')

    group.exit().remove()

    enter.append('circle')
    enter.append('text')

    group = group.merge(enter)

    group.select('circle')
    group.select('text')
         .text(d => d.idx + 1)
  })
}

/*
 * Draws the title
 */
const title = (selection, textVariation) => {
  selection.each(function (d) {
    let text = d3.select(this)
                  .selectAll('foreignObject.title')
                  .data(d => d.title ? [d] : [])

    text.exit().remove()

    let enter = text.enter()
                    .append('foreignObject')
                    .attr('class', 'title label-on-colored-background')

    enter.append('xhtml:div')
         .append('xhtml:p')

    enter.merge(text)
         .classed('dark light', false)
         .classed(textVariation, true)
         .attr('height', titleHeight)
         .select('p')
         .text(d => d.title)
  })
}

/*
 * Draws the description
 */
const description = (selection, textVariation) => {
  selection.each(function (d) {
    let title = this.querySelector('.title')
      , text = d3.select(this)
                 .selectAll('foreignObject.description')
                 .data(d => {
                   if (!d.subtitle || !d.extension) {
                      // No description
                     return []
                   }
                   return [d]
                 })

    text.exit().remove()

    let enter = text.enter()
                    .append('foreignObject')
                    .attr('class', 'description label-on-colored-background')

    enter.append('xhtml:div')
         .append('xhtml:p')

    enter.merge(text)
         .classed('dark light', false)
         .classed(textVariation, true)
         .select('p')
         .text(d => d.subtitle)
  })
}

/*
 * Draws the value
 */
const value = (selection, config, textVariation) => {
  selection.each(function (d) {
    let text = d3.select(this)
                  .selectAll('foreignObject.value')
                  .data(d => config.value ? [d] : [])

    text.exit().remove()

    let enter = text.enter()
                    .append('foreignObject')
                    .attr('class', 'value label-on-colored-background')

    enter.append('xhtml:div')
         .append('xhtml:p')

    text.merge(enter)
         .classed('dark light', false)
         .classed(textVariation, true)
        .attr('height', titleHeight)
        .select('p')
        .text(d => d.formatter(d.raw))
  })
}

export default (selection, config) => {
  selection.each(function (d) {
    let container = d3.select(this)
                      .selectAll('g.label-container')
                      .data(d => [d])
      , textVariation = colors.getTextVariation(colors.lookup(d.color))

    container.enter()
             .append('g')
             .attr('class', 'label-container')
             .merge(container)
             .call(stage, config)
             .call(title, textVariation)
             .call(description, textVariation)
             .call(value, config, textVariation)
             .select(function (d) {
               if (d.extension) {
                 d3.select(this).call(extended, titleHeight)
               } else {
                 d3.select(this).call(narrow, titleHeight)
               }
             })
  })
}
